// extracted by mini-css-extract-plugin
export default {"container":"carousel_container__sjQ-S","btn":"carousel_btn__4UDEG","prevBtn":"carousel_prevBtn__SUXrJ","nextBtn":"carousel_nextBtn__jswAM"};